
<template>
  <v-container>
    <h1 class="text-xs-left">Dashboard</h1>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  beforeMount() {
    if (this.$store.state.user == null) {
      this.$router.replace({
        path: "/admin/login"
      });
    } else {
      this.$router.replace({
        path: "/admin/page/cockpit"
      });
    }
  },
  components: {

  }
};
</script>

<style scoped>
</style>
